import { enqueueSnackbar } from 'notistack';
import React, { useState, useEffect } from 'react';
import { Box, Text, Button, Switch, Icons } from '@/theme/index';
import { capitalizeString } from '@/utils/capitalizeString';
import { StyledApiBox, StyledApiEndBox } from './components';
import { useApiKeys } from '../hooks/useApiKeys/useApiKeys';

interface ApiKeyProps {
  apiKey: {
    keyId: string;
    state: string;
    createdAt: string;
  };
}

export function ApiKey({ apiKey }: ApiKeyProps) {
  const { enableDisableApiKey, deleteApiKey } = useApiKeys();
  const [currentToggleState, setCurrentToggleState] = useState(
    apiKey.state === 'enabled'
  );
  const [currentToggleStateText, setCurrentToggleStateText] = useState(
    capitalizeString(apiKey.state)
  );

  useEffect(() => {
    setCurrentToggleStateText(capitalizeString(apiKey.state));
  }, [apiKey.state]);

  const handleDeleteClick = () => {
    deleteApiKey.mutate(apiKey.keyId);
  };

  const handleCopyClick = () => {
    enqueueSnackbar('Copied to clipboard', { variant: 'success' });
    navigator.clipboard.writeText(apiKey.keyId);
  };

  const handleChange = () => {
    setCurrentToggleState((prevState) => !prevState);
    setCurrentToggleStateText('Loading... ');
    enableDisableApiKey.mutate({
      enabled: currentToggleState,
      keyId: apiKey.keyId,
    });
  };

  return (
    <StyledApiBox>
      <Box sx={{ flex: 1 }}>
        <Button
          color="primary"
          onClick={handleCopyClick}
          sx={(theme) => ({
            [theme.breakpoints.down('sm')]: {
              paddingLeft: 0,
            },
          })}
        >
          {apiKey.keyId}
          <Icons.ContentCopy
            fontSize="small"
            sx={{ marginLeft: 1 }}
            color="primary"
          />
        </Button>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{ flex: 1 }}
      >
        <Text variant="body2">{currentToggleStateText}</Text>
        <Switch
          color="primary"
          checked={currentToggleState}
          onChange={handleChange}
        />
      </Box>
      <StyledApiEndBox>
        <Button
          onClick={handleDeleteClick}
          sx={(theme) => ({
            marginLeft: 'auto',
            [theme.breakpoints.down('sm')]: { paddingLeft: 0 },
          })}
        >
          <Icons.Clear color="primary" />
          Delete Api Key
        </Button>
      </StyledApiEndBox>
    </StyledApiBox>
  );
}
